<template>
  <div class="magic-board">
    <div class="board-container" :class="{'hide-me-mobile': seenDiscussion, 'visible-mobile': visibleUpdate}">
      <div class="board">
        <magic-board ref="board" @save="save" @close="close"></magic-board>
      </div>
    </div>
  </div>
</template>
<script>
import MagicBoard from '@/components/MagicBoard'

import auth from '@/mixins/auth'
import state from '@/mixins/component-state'

import imageProxy from '@/libs/image-proxy'

export default {
  name: 'viewMagicBoard',

  components: {
    MagicBoard
  },

  mixins: [auth, state],

  data: function () {
    return {
      loading: false,
      project: {},
      id: null,
      error: '',
      seenPage: true,
      seenModal: false,
      seenDiscussion: false,
      discussionSize: { width: 100, height: 100 },
      miniMenuHeight: 40,
      seenHowTo: false,
      settings: {},
      showWelcomeModal: false,
      disableWelcomeModal: false,
      newBoard: true,
      membership: null,
      visibleUpdate: false,
      preview: true,
      callbacks: { save: null, cancel: null }
    }
  },

  computed: {
    active: function () {
      return this.$store.getters.modalIsVisible('whiteboard')
    }
  },

  watch: {
    active: function (value) {
      if (value) {
        this.show(this.$store.getters.modalData('whiteboard'))
      }
    }
  },

  mounted: function () {
    this._register('deleteBoard', this.delete)
  },

  methods: {
    disableBoardKeyboardShortcuts: function (disable) {
      this.$refs.board.setDisableShortcuts(disable)
    },
    updateSize: function () {
      this.visibleUpdate = this.isVisible
      this.$nextTick(() => {
        this.$refs.board.updateCanvasSize()
      })
    },
    show: function (params) {
      this.callbacks.save = params.saveCallback || null
      this.callbacks.cancel = params.cancelCallback || null
      const image = params.image ? imageProxy.proxy(params.image, {}) : null
      this.$refs.board.editBoard(params.key, image, params.uuid, params.annotate)
    },
    save: function (params) {
      if (this.callbacks.save) {
        this.callbacks.save(params)
      }

      this.$emit('save', params)
      this.hideModal()
    },
    delete: function (key) {
      this.$refs.board.clear()
    },
    close: function () {
      if (this.callbacks.cancel) {
        this.callbacks.cancel()
      }
      this.hideModal()
    },
    hideModal: function () {
      this.$store.dispatch('hideWhiteboardModal')
    }
  }
}
</script>

<style lang="scss">
  @import '~styles/utils.scss';

  .board-container{
    padding-left: 0 ;
    padding-bottom: 0;
    width: 100%;
  }

  .visible-mobile {
    @include touch {
      position: fixed;
      // 47ps is the height of the header currently
      top: 47px;
      bottom: 0;
      width: 100%;
    }
  }

  /* Welcome Modal */

  .welcome-modal{
    .welcome-text .pg{
      margin-bottom: 1rem;
      @include mobile-and-ipad {
        margin-bottom: 0.7rem;
      }
    }
    .lil-line{
      height: 3px;
      width: 40%;
      background-color: $primary;
      margin: 1.5rem auto;
      margin-bottom: 2rem;
    }
    .modal-card-body{
      padding: 3rem;
      @include mobile-and-ipad {
        font-size: 0.9rem;
        padding: 1.5rem;
      }
    }
  }

  .mobile-back {
    span{
      display: inline-block;
      margin: 0 0.2rem;
    }
    align-items: center;
    position: fixed;
    z-index: 15;
    background-color: white;
    left: 0;
    padding: 0.25rem 0.25rem 0.25rem 1rem;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
    opacity: 0.95;
    margin-top: 0.8rem;

    @include touch {
      top: 0px;
    }
  }

  .wb-mobile-container {
    height: 47px;
    border-bottom: 1px solid whitesmoke;
    align-items: center;
    padding: 0.5rem;
  }

  .logo-wrapper {
    height: 30px;
    width: 100%;
    justify-content: center;
  }
  .logo {
    max-height: 30px;
    max-width: 30px;
    cursor: pointer;
  }
  .left-third, .centre-third {
    width: 33%;
  }
  .centre-third {
    justify-content: center;
  }
  .back-button{
    margin-right: 0.7rem;
    font-size: 1.25rem;
    align-items: center;
  }
  .chevron-left {
    margin-right: 0.5rem;
  }
  .magic-button {
    position: absolute;
    z-index: 10;
    left: 1rem;
    top: 1rem;
    @include touch {
      top: calc(0.5rem + 52px);
      left: 0.5rem
    }
  }

</style>
